<template>
    <div class="form-error" v-if="hasErrors" role="alert">
        <ul>
            <li v-for="msg in errorMessages" v-html="msg" tabindex="0" :aria-label="msg" role="alert"></li>
        </ul>
    </div>
</template>

<script setup lang="ts">
    import {usePortuna} from '@/composables/portuna';
    import {computed} from 'vue';
    import {useStore} from 'vuex';

    const portuna = usePortuna();

    const props = defineProps<{
        name?: string | string[];
        messages?: string | string[];
    }>();

    const store = useStore();

    const errorMessages = computed(() =>
    {
        if (props.messages)
        {
            return Array.isArray(props.messages) ? props.messages : [props.messages];
        }

        if (props.name && Array.isArray(props.name))
        {
            let errors: string[] = [];
            for (let name of props.name)
            {
                let fieldErrors = store.state.form.errors[name];
                if (Array.isArray(fieldErrors))
                {
                    errors.push(...fieldErrors);
                }
                else if (fieldErrors && typeof fieldErrors === 'object')
                {
                    errors.push(...(Object.values(fieldErrors) as string[]));
                }
            }

            return errors;
        }

        return store.state.form.errors[props.name!];
    });

    const hasErrors = computed(() =>
    {
        let messages = errorMessages.value;
        if (Array.isArray(messages) && messages.length)
        {
            return true;
        }
        else if ('string' === typeof messages && '' !== messages)
        {
            return true;
        }
        else if ('object' === typeof messages && messages)
        {
            for (let key in messages)
            {
                if (messages.hasOwnProperty(key))
                {
                    return true;
                }
            }
        }

        return false;
    });

    defineExpose(Object.assign(
        {},
        portuna,
        {
            hasErrors,
            errorMessages,
        },
    ));
</script>